import Heading, {HEADING_TYPES} from '@frontend/ui-kit/Components/Heading';
import './index.scss';

type Props = {
    errorCode: number | string,
    title: string,
    children: React.ReactNode,
};

const ErrorContent = ({errorCode, title, children}: Props) => {
    return (
        <div className='error-content'>
            <Heading type={HEADING_TYPES['1']} className='error-content__error-code'>{errorCode}</Heading>

            <Heading type={HEADING_TYPES['1']} className='error-content__header'>
                {title}
            </Heading>

            <div className='error-content-body'>
                {children}
            </div>
        </div>
    );
};

export {ErrorContent as TestableErrorContent};
export default ErrorContent;
